import React from 'react';

import MUIDivider, { DividerProps } from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { Row } from '../Row';
import { units } from '../theme/units';

const useStyles = makeStyles()(() => ({
  textSeparator: {
    width: 'auto',
    flexGrow: 1,
  },
  text: {
    padding: units.yx(0, 0.3),
  },
  'kind-spaced-m': {
    margin: units.yx(1, 0),
  },
  'kind-spaced-l': {
    margin: units.yx(1.5, 0),
  },
}));

type Kind = 'spaced-m' | 'spaced-l';

export interface Props {
  text?: string;
  kind?: Kind;
  // For some reason we need to explicitly define `className` prop.
  className?: string;
  dividerProps?: DividerProps;
}

const Divider: React.FC<Props> = ({
  text,
  kind,
  className,
  dividerProps = {},
  ...rest
}) => {
  const { classes, cx } = useStyles();

  const divider = (
    <MUIDivider
      {...rest}
      {...dividerProps}
      className={cx(className, {
        [classes[`kind-${kind}` as keyof typeof classes]]: Boolean(kind),
        [classes.textSeparator]: Boolean(text),
      })}
    />
  );

  // If there is no provided text, fall back to MUI divider
  if (!text) {
    return divider;
  }

  return (
    <Row justifyContent="space-between" alignItems="center">
      {divider}
      <Typography className={classes.text}>{text}</Typography>
      {divider}
    </Row>
  );
};

export { Divider };
